import { combineReducers } from 'redux'

import { RootState } from 'src/store/initialStore'

import notifications from './notifications'

const rootReducer = combineReducers<RootState>({ notifications })

export default rootReducer
